import BaseService from '../base-service';
import { StandardResponse, createStandardResponse } from '../../models/standard-response';
import { ISecureLinkVerificationResponse } from '../../models/federated-account-migration';

export const verifySecureLink = async (token: string): Promise<StandardResponse<ISecureLinkVerificationResponse>> => {
  try {
    const res = await BaseService({
      url: `/driver/federated-accounts/access/secure-link/verify`,
      method: 'GET',
      data: { byPassAuth: true },
      headers: { token },
    });
    return createStandardResponse<ISecureLinkVerificationResponse>(res.status, res.data.data, res.data.message, null);
  } catch (e) {
    return Promise.reject(e);
  }
};

export const verifyAccessOTP = async (token: string, otp: string): Promise<StandardResponse<boolean>> => {
  try {
    const res = await BaseService({
      url: `/driver/federated-accounts/access/otp/verify`,
      method: 'PUT',
      data: { otp, byPassAuth: true },
      headers: { token },
    });
    return createStandardResponse<boolean>(res.status, res.data.data, res.data.message, null);
  } catch (e) {
    return Promise.reject(e);
  }
};

export const resendAccessOTP = async (token: string): Promise<StandardResponse<boolean>> => {
  try {
    const res = await BaseService({
      url: `/driver/federated-accounts/access/otp/resend`,
      method: 'PUT',
      data: { byPassAuth: true },
      headers: { token },
    });
    return createStandardResponse<boolean>(res.status, res.data.data, res.data.message, null);
  } catch (e) {
    return Promise.reject(e);
  }
};

export const deleteFederatedAccount = async (token: string): Promise<StandardResponse<boolean>> => {
  try {
    const res = await BaseService({
      url: `/driver/federated-accounts`,
      method: 'DELETE',
      data: { byPassAuth: true },
      headers: { token },
    });
    return createStandardResponse<boolean>(res.status, null, res.data.message, null);
  } catch (e) {
    return Promise.reject(e);
  }
};

export const migrateAccountInHouse = async (token: string, new_email: string): Promise<StandardResponse<boolean>> => {
  try {
    const res = await BaseService({
      url: `/driver/federated-accounts/migrate/in-house`,
      method: 'POST',
      data: { new_email, byPassAuth: true },
      headers: { token },
    });
    return createStandardResponse<boolean>(res.status, null, res.data.message, null);
  } catch (e) {
    return Promise.reject(e);
  }
};

export const migrateAccountToThirdParty = async (
  token: string,
  cognitoUsername: string,
): Promise<StandardResponse<boolean>> => {
  try {
    const res = await BaseService({
      url: `/driver/federated-accounts/migrate/third-party`,
      method: 'POST',
      data: { cognito_username: cognitoUsername, byPassAuth: true },
      headers: { token },
    });
    return createStandardResponse<boolean>(res.status, null, res.data.message, null);
  } catch (e) {
    return Promise.reject(e);
  }
};
